import React, { useState } from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import MealPickerMeal from './MealPickerMeal';

const MealPicker = (props) => {
  const [showMenu, setShowMenu] = useState(false);
  const { dailyMenu, selectedMealName, selectMeal, selectedDate, locationName } = props;

  function hideShowMenu() {
    if (dailyMenu.length > 1) {
      setShowMenu(!showMenu)
    }
  }

  function renderMealPickerMenu() {
    return <div key="mealpicker-menu" className="mealpicker-menu">
      <div className="mealpicker-menu-meals">
        {
          dailyMenu.map((meal) => {
            return <MealPickerMeal locationName={locationName} selectedDate={selectedDate} selectMeal={selectMeal} hideShowMenu={hideShowMenu} link={true} key={"meal-" + meal.name} {...meal}
            />
          })
        }
      </div>
    </div>
  }

  function getSelectedMeal(selectedMealName) {
    return dailyMenu.find(function (meal) {
      return meal.name === selectedMealName
    });
  }

  let selectedMeal = getSelectedMeal(selectedMealName);
  if (dailyMenu.length > 0) {
    return <div className="mealpicker-container">

      {showMenu ? <div className="obfusicator" onClick={hideShowMenu}></div> : false}

      <div key="mealpicker-menu-button" className="mealpicker" onClick={hideShowMenu}>

        {selectedMeal ? <MealPickerMeal locationName={locationName} selectedDate={selectedDate} link={false} {...selectedMeal} alt={true} /> : null}

        {dailyMenu.length > 1 ? showMenu ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon /> : null}

      </div>

      {showMenu ? renderMealPickerMenu() : null}

    </div>
  } else {
    return null;
  }
}

export default MealPicker;